<app-service-detail (window:resize)="onResize($event)">
  <div class="col-12 pl-2 pl-md-5 pr-2 pr-md-4 mt-5 mb-4" *ngIf="showPublish">

    <tabset type="tabs"
      class="sm-margin tab-container new-tab-container"
      style="background: white" id="tabsContainer">
      <ul role="tablist" class="nav nav-tabs new-tabs" id="tabsList">
        <li 
          [ngClass]="{'active': currentRoute === 'configuration'}">
          <a (click)="navigateRoute('configuration')"
            [ngClass]="{'active': currentRoute === 'configuration'}" role="tab">
            <span>{{ 'Service configuration' | translate }}</span>
          </a>
        </li>
        <li [ngClass]="{'active': currentRoute === 'options'}" *ngIf="defaultMyAccountServiceId !== serviceId">
          <a (click)="navigateRoute('options')"
            [ngClass]="{'active': currentRoute === 'options'}" role="tab">
            <span>{{ 'Service options' | translate }}</span>
          </a>
        </li>
        <li [ngClass]="{'active': currentRoute === 'history'}">
          <a (click)="navigateRoute('history')"
            [ngClass]="{'active': currentRoute === 'history'}" role="tab">
            <span>{{ 'service.publish_history' | translate }}</span>
          </a>
        </li>
        <li [ngClass]="{'active': currentRoute === 'export'}">
          <a (click)="navigateRoute('export')"
            [ngClass]="{'active': currentRoute === 'export'}" role="tab">
            <span>{{ 'Import/Export service' | translate }}</span>
          </a>
        </li>
        <li [ngClass]="{'active': currentRoute === 'databases'}">
          <a (click)="navigateRoute('databases')"
            [ngClass]="{'active': currentRoute === 'databases'}" role="tab">
            <span>{{ 'Databases' | translate }}</span>
          </a>
        </li>
        <li [ngClass]="{'active': currentRoute === 'debug'}">
          <a (click)="navigateRoute('debug')"
            [ngClass]="{'active': currentRoute === 'debug'}" role="tab">
            <span>{{ 'Debugging' | translate }}</span>
          </a>
        </li>
      </ul>
      <ul role="tablist" class="nav nav-tabs new-tabs dropdown-tabs" id="tabsResp">
        <li class="dropdown active" dropdown>
          <a class="" href="#" (click)="false" dropdownToggle>
            <span *ngIf="currentRoute === 'configuration'">{{ 'Service configuration' | translate }}</span>
            <span *ngIf="currentRoute === 'options' && (defaultMyAccountServiceId !== serviceId)">{{ 'Service options' | translate }}</span>
            <span *ngIf="currentRoute === 'history'">{{ 'service.publish_history' | translate }}</span>
            <span *ngIf="currentRoute === 'export'">{{ 'Export service' | translate }}</span>
            <span *ngIf="currentRoute === 'databases'">{{ 'Databases' | translate }}</span>
            <span *ngIf="currentRoute === 'debug'">{{ 'Debugging' | translate }}</span>
            <i class="fas fa-angle-down ml-3"></i>
            <i class="fas fa-angle-up ml-3"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-left" *dropdownMenu>
            <a *ngIf="currentRoute !== 'configuration'" (click)="navigateRoute('configuration')" class="dropdown-item py-2" [ngClass]="{'active': currentRoute === 'configuration'}" role="tab">
              <span>{{ 'Service configuration' | translate }}</span>
            </a>
            <a *ngIf="currentRoute !== 'options' && (defaultMyAccountServiceId !== serviceId)" (click)="navigateRoute('options')" class="dropdown-item py-2" [ngClass]="{'active': currentRoute === 'options'}" role="tab">
              <span>{{ 'Service options' | translate }}</span>
            </a>
            <a *ngIf="currentRoute !== 'history'" (click)="navigateRoute('history')" class="dropdown-item py-2" [ngClass]="{'active': currentRoute === 'history'}" role="tab">
              <span>{{ 'service.publish_history' | translate }}</span>
            </a>
            <a *ngIf="currentRoute !== 'export'" (click)="navigateRoute('export')" class="dropdown-item py-2" [ngClass]="{'active': currentRoute === 'export'}" role="tab">
              <span>{{ 'Export service' | translate }}</span>
            </a>
            <a *ngIf="currentRoute !== 'databases'" (click)="navigateRoute('databases')" class="dropdown-item py-2" [ngClass]="{'active': currentRoute === 'databases'}" role="tab">
              <span>{{ 'Databases' | translate }}</span>
            </a>
            <a *ngIf="currentRoute !== 'debug'" (click)="navigateRoute('debug')" class="dropdown-item py-2" [ngClass]="{'active': currentRoute === 'debug'}" role="tab">
              <span>{{ 'Debugging' | translate }}</span>
            </a>
          </div>
        </li>
      </ul>
      <div class="tab-content {{(currentRoute === 'configuration' || tabsType === 'dropdown') ? 'first-tab' : ''}}">
        <router-outlet></router-outlet>
      </div>
    </tabset>

  </div>

</app-service-detail>
